import { render, staticRenderFns } from "./SignUpForm.vue?vue&type=template&id=f6da2992&scoped=true&lang=pug"
import script from "./SignUpForm.vue?vue&type=script&lang=js"
export * from "./SignUpForm.vue?vue&type=script&lang=js"
import style0 from "./SignUpForm.vue?vue&type=style&index=0&id=f6da2992&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6da2992",
  null
  
)

export default component.exports